import { useMutation } from '@tanstack/vue-query'
import financialBff from '~/services-v2/financial-bff/financial-bff'

export default function useMarkNotificationClicked() {
  return useMutation({
    mutationFn: async (notificationId: number) => {
      const res = await financialBff('mutation')({
        markNotificationClicked: [
          { notificationId },
          true,
        ],
      })
      return res.markNotificationClicked
    },
  })
}
